export default __webpack_public_path__ + "static/media/bezold.7201ea58.jpg";